import React from 'react';
import { Link } from 'react-router-dom';

const UserList = props => {
  if (!props.users) {
    return (
      <div className='broad'>Loading...</div>
    )
  }

  if (props.users.length === 0) {
    return (
      <div className='broad'>
        No users...
      </div>
    );
  }

  return (
    <table className="dataTable">
      <thead>
        <tr>
          <th>Key</th>
          <th>Firstname</th>
          <th>Lastname</th>
          <th>Email</th>
          <th>Email&nbsp;verified</th>
          <th>Phone</th>
          <th>Status</th>
          <th>Registered</th>
        </tr>
      </thead>
      <tbody>
        {
          props.users.map(user => {
            return (
              <tr key={user.email}>
                <td className="keyfield"><Link to={`/users/${user.key}`}>{user.key}</Link></td>
                <td>{user.firstname}</td>
                <td>{user.lastname}</td>
                <td>{user.email}</td>
                <td>{user.email_verified === true ? 'Yes' : 'No'}</td>
                <td>{user.phone}</td>
                <td>{user.locked ? 'locked' : 'active'}</td>
                <td>{user.created}</td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
  );
};

export default UserList;



// WEBPACK FOOTER //
// ./src/components/widgets/UserList.js